import { updateUserState } from "../store/slice/userSlice";
import { checkIsValidArray, manageErrorLogs } from "./commonFunction";
import {
  checkTablesInDB,
  clearTables,
  insertDataInDB,
  safeTransaction,
} from "./db";

export const insertUserDataInDB = async (data, dispatch) => {
  try {
    const tables = ["userData"];
    checkTablesInDB(tables);
    dispatch(updateUserState(data));
    await safeTransaction(tables, async (tx) => {
      const userDataTable = tx.table(tables[0]);
      if (data?.id) {
        await userDataTable.put(data);
      }
    });
  } catch (error) {
    manageErrorLogs(error);
    return null;
  }
};

export const insertRestaurantDetailsInDB = async (data) => {
  try {
    const tables = [
      "restaurantDetails",
      "govermentMarketDetails",
      "addedRestaurantDetails",
    ];
    checkTablesInDB(tables);

    await safeTransaction(tables, async (tx) => {
      const restaurantDetailsTable = tx.table(tables[0]);
      const govermentMarketDetailsTable = tx.table(tables[1]);
      await clearTables(tx, tables);

      if (checkIsValidArray(data?.company)) {
        const newData = data?.company.map((item, i) => {
          return {
            ...item,
            id: i + 1,
            restaurant_id: item?.id,
          };
        });
        await insertDataInDB(restaurantDetailsTable, newData);
      }

      if (checkIsValidArray(data?.localGov)) {
        const newData = data?.localGov.map((item, i) => {
          return {
            ...item,
            id: i + 1,
            restaurant_id: item?.id,
          };
        });
        await insertDataInDB(govermentMarketDetailsTable, newData);
      }
    });
  } catch (error) {
    manageErrorLogs(error);
    return null;
  }
};

export const insertRestaurantReportsInDB = async (data) => {
  try {
    const tables = ["restaurantDetailsReports", "govermentMarketReports"];
    checkTablesInDB(tables);
    await safeTransaction(tables, async (tx) => {
      const restaurantReportsTable = tx.table(tables[0]);
      const govermentMarketReports = tx.table(tables[1]);

      await clearTables(tx, tables);

      if (checkIsValidArray(data?.company)) {
        const newData = data?.company?.map((item, i) => {
          return {
            ...item,
            id: i + 1,
            is_company: 1,
            is_localgov: 0,
            restaurant_id: item?.id,
          };
        });
        await insertDataInDB(restaurantReportsTable, newData);
      }

      if (checkIsValidArray(data?.localGov)) {
        const newData = data?.localGov?.map((item, i) => {
          return {
            ...item,
            id: i + 1,
            is_company: 0,
            is_localgov: 1,
            restaurant_id: item?.id,
          };
        });
        await insertDataInDB(govermentMarketReports, newData);
      }
    });
  } catch (error) {
    manageErrorLogs(error);
    return null;
  }
};
